import styles from './CartSummary.module.scss'
import { CartModel } from '@/types/api'
import React from 'react'
import CartRow, { ColumnSettings } from '../CartRow/CartRow'
import usePrice from '@/utils/hooks/usePrice'
import CartColumn from '../CartColumn/CartColumn'
import { useTranslation } from 'next-i18next'

type Props = {
  cart?: CartModel
}

const CartSummary = ({ cart }: Props) => {
  const { t } = useTranslation('cart')
  const { formatPrice } = usePrice()

  const columns: ColumnSettings[] = [
    {
      label: t('net') || '',
      value: formatPrice(cart?.totalExludingVat),
    },
    {
      label: t('vat') || '',
      value: formatPrice(cart?.vatAmount),
    },
    {},
    {},
    {},
    {},
    {
      label: t('total') || '',
      value: formatPrice(cart?.totalAmount, true),
      textAlign: 'right',
    },
  ]

  return (
    <div className={styles.component}>
      <CartRow
        columns={columns}
      />
      <div className={styles.toPay}>
        <CartColumn
          className='col-xs-offset-10 col-xs-2'
          textAlign='right'
        >
          <>
            <label>{t('total') || ''}</label>
            <div>{formatPrice(cart?.totalAmount, true)}</div>
          </>
        </CartColumn>
      </div>
    </div>
  )
}

export default CartSummary
